import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/home/index.vue"),
  },
  {
    path: "/exhibition",
    name: "exhibition",
    component: () => import("../views/exhibition/index.vue"),
  },
  {
    path: "/article",
    name: "article",
    component: () => import("../views/article/index.vue"),
  },
  {
    path: "/information",
    name: "information",
    component: () => import("../views/information/index.vue"),
  },
  {
    path: "/scene",
    name: "scene",
    component: () => import("../views/scene/index.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
